import React, { Component } from 'react';
import { IAppState, IAction } from '../../models/action/core';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { ICustomIframeProps } from '../../models/components/custom-iframe';
import { Log } from 'ng2-logger';
import ApiClient from '../../api/alms-api';

const iframeRef = React.createRef<HTMLIFrameElement>();

let _apiClient: ApiClient;
const _logger = Log.create('custom iframe');
export class CCustomIframe extends Component<ICustomIframeProps> {

  constructor(props: any) {
    super(props);
    _apiClient = new ApiClient();
  }

  setClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  setCloseModal = () => {
    this.setClose();
  };

  handleIframeLoad = () => {
    if (this.props.name === "previewCourse") {
      const iframeWindow = iframeRef.current!.contentWindow;
      const iframeDocument = iframeWindow!.document;

      iframeDocument.addEventListener('click', this.handleLinkClick);
    }

    if (this.props.name === "previewUsers") {
      const iframeWindow = iframeRef.current!.contentWindow;
      const iframeDocument = iframeWindow?.document;
      if(iframeDocument){
        iframeDocument.addEventListener('click', this.handleSimulateUser);
      }
    }

  };

  handleLinkClick = (event: any) => {

    const iframeWindow = iframeRef.current!.contentWindow;

    const clickedLink = event.target;
    const id = clickedLink.getAttribute('id');
    if (id && id.includes('courselink')) {
      event.preventDefault();
      const param = {
        url: window.appSettings.DEFAULT_URL,
        courseId: id.split('-').pop()
      }
      _apiClient.RequestAsync('POST', 'api/course/redirectcoursepage', param, '').then((responseData: Response) => {
        if (responseData.status !== 200) {
          return null;
        } else {
          return responseData.json();
        }
      }).then((result: any) => {
        if (result != null && result.length > 0) {
          window.location.href = result;

        }
      })
    }

  };

  handleSimulateUser = (event: any) => {

    const iframeWindow = iframeRef.current!.contentWindow;
    const clickedLink = event.target;
    const className = clickedLink.getAttribute('class');
    if (className && className === "btnSimulateUser") {
      event.preventDefault();

      if(iframeWindow){
        window.open(iframeWindow.location.href, '_self');
      }

    }
  }


  public render() {
    return (
      <div >
        <iframe
          id={'iframe-' + this.props.id}
          name={this.props.name}
          style={{
            overflow: 'hidden',
            overflowX: 'hidden',
            overflowY: 'hidden',
            height: this.props.height,
            width: this.props.width,
            minHeight: this.props.minHeight ? this.props.minHeight : '70vh',
            position: 'relative',
            alignItems: 'center',
            justifyContent: 'center',
            display: "flex",
          }}
          height={this.props.height}
          width={this.props.width}
          src={this.props.src}
          ref={iframeRef}
          onLoad={this.handleIframeLoad}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: IAppState, ownProps: ICustomIframeProps): ICustomIframeProps => {
  if (!state) {
    return ownProps;
  }

  const newProps: ICustomIframeProps = Object.assign({}, ownProps, {
  });
  return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
  return ({
    dispatch
  });
};

const CustomIframe = connect(
  mapStateToProps,
  dispatchProps
)(CCustomIframe);


export default CustomIframe;
